import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/Auth.css';

const Register: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    phone: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://ceshi.lightark.cc/api/v1/users/register', formData);
      if (response.status === 200) {
        navigate('/login');
      }
    } catch (err) {
      setError('注册失败，请检查输入信息');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1>注册新账号</h1>
        <p>创建您的账号以开始使用</p>
        <form onSubmit={handleSubmit}>
          {error && (
            <div className="text-red-500 text-center mb-4">{error}</div>
          )}
          <div className="input-group">
            <input
              type="text"
              name="username"
              placeholder="用户名"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="email"
              name="email"
              placeholder="邮箱"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              name="password"
              placeholder="密码"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="tel"
              name="phone"
              placeholder="手机号"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="auth-button">
            注册
          </button>
        </form>
        <div className="auth-footer">
          <a href="/login">已有账号？立即登录</a>
        </div>
      </div>
    </div>
  );
};

export default Register; 